module.exports = __webpack_public_path__ + "media/dog-personality-traits/paws-b1187465.svg";